import {EventType, WebhookHttpVerbCallback} from './webhook-subscription.model';
import * as moment from 'moment';
import { Moment } from 'moment';

export class WebhookEvent {

  public id: string;
  public subscriberId: string;
  public publicReference: string;
  public triggeredDate: Moment;
  public eventType: EventType;
  public status: EventStatus;
  public externalReference1?: string[];
  public externalReference2?: string[];
  public externalReference3?: string[];
  public message: any;
  public nextTryDate?: Moment;
  public eventHistories: WebhookEventHistory[];

  public selected = false;

  public static fromDto(we): WebhookEvent {
    if (!we) {
      return null;
    }

    const webhookEvent = new WebhookEvent();

    webhookEvent.id = we.id;
    webhookEvent.subscriberId = we.subscriberId;
    webhookEvent.publicReference = we.publicReference;
    webhookEvent.triggeredDate = we.triggeredDate ? moment(we.triggeredDate) : null;
    webhookEvent.eventType = we.eventType;
    webhookEvent.status = we.status;
    webhookEvent.externalReference1 = we.externalReference1;
    webhookEvent.externalReference2 = we.externalReference2;
    webhookEvent.externalReference3 = we.externalReference3;
    webhookEvent.message = we.message;
    webhookEvent.nextTryDate = we.nextTryDate ? moment(we.nextTryDate) : null;
    webhookEvent.eventHistories = we.eventHistories ? we.eventHistories.map(eh => WebhookEventHistory.fromDto(eh)) : [];

    return webhookEvent;
  }
}

export class WebhookEventHistory {

  public id: string;
  public triggerSource: TriggerSource;
  public createdAt: Moment;
  public httpVerbCallback: WebhookHttpVerbCallback;
  public urlCallback: string;
  public status: EventHistoryStatus;
  public comment?: string;

  public static fromDto(weh): WebhookEventHistory {
    if (!weh) {
      return null;
    }

    const webhookEventHistory = new WebhookEventHistory();
    webhookEventHistory.id = weh.id;
    webhookEventHistory.triggerSource = weh.triggerSource;
    webhookEventHistory.createdAt = weh.createdAt ? moment(weh.createdAt) : null;
    webhookEventHistory.httpVerbCallback = weh.httpVerbCallback;
    webhookEventHistory.urlCallback = weh.urlCallback;
    webhookEventHistory.status = weh.status;
    webhookEventHistory.comment = weh.comment;
    return webhookEventHistory;
  }
}

export class WebhookEventSearchResult {

  public id: string;
  public publicReference: string;
  public triggeredDate: Moment;
  public eventType: EventType;
  public status: EventStatus;
  public externalReference1: string[];
  public externalReference2: string[];
  public externalReference3: string[];
  public nextTryDate?: Moment;

  public static fromDto(we): WebhookEventSearchResult {
    if (!we) {
      return null;
    }

    const webhookEventSearchResult = new WebhookEventSearchResult();

    webhookEventSearchResult.id = we.id;
    webhookEventSearchResult.publicReference = we.publicReference;
    webhookEventSearchResult.triggeredDate = we.triggeredDate ? moment(we.triggeredDate) : null;
    webhookEventSearchResult.eventType = we.eventType;
    webhookEventSearchResult.status = we.status;
    webhookEventSearchResult.externalReference1 = we.externalReference1;
    webhookEventSearchResult.externalReference2 = we.externalReference2;
    webhookEventSearchResult.externalReference3 = we.externalReference3;
    webhookEventSearchResult.nextTryDate = we.nextTryDate ? moment(we.nextTryDate) : null;

    return webhookEventSearchResult;
  }
}

export enum EventStatus {
  SENT = 'SENT',
  FAILED = 'FAILED',
  RETRYING = 'RETRYING',
  IGNORED = 'IGNORED',
  IN_PROGRESS = 'IN_PROGRESS',
}

export function allEventStatus(): EventStatus[] {
  return [EventStatus.SENT, EventStatus.FAILED, EventStatus.RETRYING, EventStatus.IGNORED, EventStatus.IN_PROGRESS];
}

export enum EventHistoryStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}

export enum TriggerSource {
  AUTOMATIC = 'AUTOMATIC',
  MANUAL = 'MANUAL',
}
